module.exports = __webpack_public_path__ + "static/media/daechoo.eb09dcde.jpg";